// extracted by mini-css-extract-plugin
export var content = "content-1EG";
export var has_columns = "has_columns-eaH";
export var margin_bottom_36 = "margin_bottom_36-gyf";
export var split_header = "split_header-7It";